import React, { Fragment, useContext, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { TextField, IconButton } from "@material-ui/core";
import { Clear } from "@material-ui/icons";

// Contexts
import FacebookProfilesDashboardContext from "../../../../context/facebook_profiles/dashboard/DashboardContext";

const useStyles = makeStyles((theme) => ({
  input: {
    marginLeft: "1rem",
    fontSize: "0.9rem",
  },
  button: {
    padding: 5,
    textTransform: "none",
    "&:focus": {
      outline: "none",
    },
  },
}));

const DashboardStats_01_Name = () => {
  const classes = useStyles();

  const {
    current_tab,
    stats_name_filter,
    setStatsFilter,
    getCampaignFiltered,
    getAdSetFiltered,
    getAdFiltered,
  } = useContext(FacebookProfilesDashboardContext);

  const handleChange = (e) => {
    setStatsFilter("stats_name_filter", {
      current_tab,
      text: e.target.value,
    });
  };

  const onClear = (e) => {
    setStatsFilter("stats_name_filter", {
      current_tab,
      text: "",
    });
  };

  useEffect(() => {
    if (current_tab === "Campaign") getCampaignFiltered();
    if (current_tab === "Ad Set") getAdSetFiltered();
    if (current_tab === "Ad") getAdFiltered();
  }, [stats_name_filter]);

  return (
    <Fragment>
      <TextField
        className={classes.input}
        placeholder={`Search by name...`}
        value={stats_name_filter[current_tab]}
        onChange={handleChange}
      />
      <IconButton
        className={classes.button}
        type="submit"
        size="small"
        onClick={onClear}
      >
        {stats_name_filter[current_tab] && <Clear />}{" "}
      </IconButton>{" "}
    </Fragment>
  );
};

export default DashboardStats_01_Name;
